import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CardComponent } from '../card.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-event-card',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventCardComponent extends CardComponent implements OnInit {
  @Input() classes = 'background-light general-white-bg';
  @Input() topLeftClasses = 'general-white-30-bg brown5-bg-md badge-spacing';
  @Input() topLeftTextClasses = 'general-white brown2-md';
  @Input() topRightTextClasses = 'brown7';
  @Input() titleClasses = 'h4-nc cream-light';
  @Input() descriptionClasses = 'brown8';
  @Input() linkClasses = 'cream-link';
  @Input() bottomRight = '<i class=\'fas fa-calendar-alt\'></i>';
  @Input() bottomRightClasses = 'cream-ultra-light brown5-md';
  @Input() linkAboveDescription = false;

  constructor(sanitize: DomSanitizer, router: Router) {
    super(sanitize, router);
  }

  ngOnInit() {
    // console.log('fullCardClick', this.fullCardClick);
  }

}
